module.exports = __webpack_public_path__ + "assets/img/26d801468f0f913111a94739e7e83574.svg";